import React from "react"

const SourceTypeIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path id="icons8-quote" d="M12,4a8.009,8.009,0,0,0-8,8,7.926,7.926,0,0,0,.9,3.627l-.867,3.1A1.021,1.021,0,0,0,5.27,19.962l3.107-.867A7.924,7.924,0,0,0,12,20,8,8,0,1,0,12,4ZM9.6,9.2a1.6,1.6,0,0,1,1.6,1.6c0,.034-.008.067-.01.1a.584.584,0,0,1,.01.1,5.517,5.517,0,0,1-1.84,4.08.6.6,0,0,1-.72-.96,3.364,3.364,0,0,0,1.124-1.737A1.582,1.582,0,0,1,9.6,12.4a1.6,1.6,0,1,1,0-3.2Zm4.8,0A1.6,1.6,0,0,1,16,10.8c0,.034-.008.067-.01.1A.584.584,0,0,1,16,11a5.517,5.517,0,0,1-1.84,4.08.6.6,0,0,1-.72-.96,3.364,3.364,0,0,0,1.124-1.737,1.582,1.582,0,0,1-.164.016,1.6,1.6,0,0,1,0-3.2Z" transform="translate(-4 -3.998)" fill="#896db3" />
        </svg>
    )
}
export default SourceTypeIcon